import { IPatient, IServiceTask, Therapy } from '@alberta/konexi-shared';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { map } from '@common/mapper/mapper';
import { ModalController } from '@ionic/angular';
import { TherapyService } from '@services/tenant-config/therapy.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ServiceTaskViewModel } from 'src/app/business/serviceTask/view-model/service-task-view-model';
import { DocumentEntityType } from 'src/app/shared/models/swodoc/document-entity-type';

import { TemplateComponentModel } from '../../../../swodoc/_models/template-component-model';
import { SwodocCreateService } from '../../../../swodoc/services/swodoc-create.service';
import { TemplateDto } from '../../../models/swodoc/template-dto.model';

@Component({
  selector: 'itl-document-create',
  templateUrl: './document-create.component.html',
  styleUrls: ['./document-create.component.scss'],
})
export class DocumentCreateComponent implements OnInit {
  @Input()
  public entityType: DocumentEntityType;
  @Input()
  public patient: IPatient;
  @Input()
  public serviceTask: IServiceTask;

  public readonly items$: Observable<TemplateDto[]>;
  public busy = false;
  public loading = false;
  public query: string;
  public serviceTaskViewModel: ServiceTaskViewModel;

  private _selectedTherapy: number;
  private _selectedTherapyType: number;

  constructor(
    private _templateModel: TemplateComponentModel,
    public modalController: ModalController,
    private _swodocCreateService: SwodocCreateService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _therapyService: TherapyService
  ) {
    this.items$ = this._templateModel.select();
  }

  public async ngOnInit() {
    this.filterTemplates();
    let selectionItems = await this._therapyService.getTherapySelectionItems();
    selectionItems = selectionItems.filter(item => item.id !== Therapy.NN);
    if (this.serviceTask) {
      this.serviceTaskViewModel = map(this.serviceTask, new ServiceTaskViewModel());
      this.serviceTaskViewModel.initialize();
      this._selectedTherapy = this.serviceTaskViewModel.therapyId;
      this._selectedTherapyType = this.serviceTaskViewModel.therapyTypeId;
    }
  }

  public async createAudit(template) {
    this.loading = true;
    await this.modalController.dismiss(template, null, 'documentCreateModal').catch(error => console.log(error));
    this.loading = false;
  }

  private async filterTemplates(searchValue?: string) {
    this.loading = true;
    this._templateModel.registerItems([]);
    this._templateModel
      .getAll()
      .pipe(take(1))
      .subscribe(async templates => {
        const filteredTemplates = await this._swodocCreateService.sortAndFilterTemplates(
          templates,
          this._selectedTherapy,
          this._selectedTherapyType,
          this.patient,
          this.entityType,
          searchValue
        );
        this._templateModel.registerItems(filteredTemplates);

        if (this.entityType === 'prescription' && filteredTemplates.length === 1) {
          setTimeout(() => {
            this.createAudit(filteredTemplates[0]);
          }, 200);
        }

        this.loading = false;
        this._changeDetectorRef.detectChanges();
      });
  }
  async clearSearch() {
    await this.search('***');
  }

  async search($event) {
    this.busy = true;
    if ($event === '***' || $event === '') {
      this.filterTemplates();
    } else if ($event.length > 2) {
      this.filterTemplates($event);
    }
    this.busy = false;
  }
}
